import React from 'react';

import { faClockRotateLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';

const HistoryEmptyState = () => {

  return <React.Fragment>
    <Empty className="bg-white">
      <Empty.Media>
        <FontAwesomeIcon icon={faClockRotateLeft} />
      </Empty.Media>
      <Empty.Title>No history to display.</Empty.Title>
    </Empty>
  </React.Fragment>;
};

export default HistoryEmptyState;
